export class EmployeeEarning {
  Id: string;
  IsActive: boolean;
  HoursPaidPerPayroll: number;
  Rates: EmployeeEarningRate[];
  IntegrityHash: string;
}

export class EmployeeEarningRate {
  SequenceNumber: number;
  EffectiveDate: Date | string;
  LastChangedOn: Date;
  LastEditorId: string;
  Amount: number;
  IntegrityHash: string;
}
